import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Bogotá, Colombia'
}, {
  name: 'Carolina S.',
  province: 'Ciudad de México, México'
}, {
  name: 'Valentina R.',
  province: 'Lima, Perú'
}, {
  name: 'Luciana M.',
  province: 'Santiago, Chile'
}, {
  name: 'Florencia G.',
  province: 'Guayaquil, Ecuador'
}, {
  name: 'Romina P.',
  province: 'Montevideo, Uruguay'
}, {
  name: 'Agustina D.',
  province: 'San José, Costa Rica'
}, {
  name: 'Camila T.',
  province: 'Medellín, Colombia'
}, {
  name: 'Daniela F.',
  province: 'Guadalajara, México'
}, {
  name: 'Sofía B.',
  province: 'Quito, Ecuador'
}, {
  name: 'Paula V.',
  province: 'Asunción, Paraguay'
}, {
  name: 'Andrea K.',
  province: 'La Paz, Bolivia'
}, {
  name: 'Julieta H.',
  province: 'Cali, Colombia'
}, {
  name: 'Natalia C.',
  province: 'Arequipa, Perú'
}, {
  name: 'Gabriela R.',
  province: 'Panamá, Panamá'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Show next one after 12-20 seconds
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-28 md:bottom-4 left-4 z-[50] max-w-[250px] sm:max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-422">
      <div className="bg-white border border-[#e8d5f0] rounded-xl p-3.5 shadow-[0_10px_30px_rgba(61,42,95,0.15)] backdrop-blur-sm" data-id="element-423">
        <div className="flex items-start gap-3" data-id="element-424">
          <div className="w-9 h-9 rounded-full bg-[#f3e9f7] border border-[#e8d5f0] flex items-center justify-center flex-shrink-0" data-id="element-425">
            <span className="text-sm" data-id="element-426">✨</span>
          </div>
          <div className="min-w-0" data-id="element-427">
            <p className="text-[#3d2a5f] text-sm font-semibold leading-tight" data-id="element-428">
              {purchase.name}
              <span className="text-[#6b5a85] font-normal" data-id="element-429"> de </span>
              <span className="text-[#c9a14d]" data-id="element-430">{purchase.province}</span>
            </p>
            <p className="text-[#6b5a85] text-xs mt-0.5" data-id="element-431">
              adquirió{' '}
              <span className="text-[#3d2a5f] font-medium" data-id="element-432">
                MegaPack Maestría Reiki
              </span>
            </p>
            <p className="text-[#6b5a85]/70 text-[10px] mt-1" data-id="element-433">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}